var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isAuthorized)?_c('span',[_vm._t("default")],2):_c('span')
}
var staticRenderFns = []

export { render, staticRenderFns }